module.exports = __webpack_public_path__ + "img/partner_1.a5029176.png";